import {Route,Switch,BrowserRouter } from "react-router-dom";

import ConsoleUsersTable from "components/Doobi/ConsoleUsers";
import DoobiHeader from "components/Headers/DoobiHeader";

const ConsoleUsersRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="ConsoleUsers" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={ConsoleUsersTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ConsoleUsersRoute;
